export function formatISODate(date: string): string {
  return date.slice(0, 10);
}

export function formatLocaleDate(date: Date | string): string {
  if (typeof date === "string") {
    date = new Date(date.toLocaleString());
  }
  const local = date
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/");
  return `${local[2]}/${local[1]}/${local[0]}`;
}

export function formatLocaleDateWithTime(date: Date): string {
  const local = date
    .toLocaleDateString("en-GB", {
      minute: "2-digit",
      hour: "2-digit",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })
    .split(",");
  const localDate = local[0].split("/");
  return `${localDate[2]}/${localDate[1]}/${localDate[0]}, ${local[1]}`;
}

export function formatDate(date: string | Date) {
  if (date) {
    return formatLocaleDateWithTime(
      date instanceof Date ? date : new Date(date)
    );
  }
}

export function formatTRUELocaleDateWithTime(date: Date): string {
  const local = date
    .toLocaleDateString("es-MX", {
      minute: "2-digit",
      hour: "2-digit",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })
    .split(",");
  const localDate = local[0].split("/");
  return `${localDate[2]}/${localDate[1]}/${localDate[0]}, ${local[1]}`;
}

export function formatMXDate(date: Date): string {
  const local = date
    .toLocaleDateString("es-MX")
    .split(",");
  return `${local[0]}`;
}

export function formatMXDateRange(dates: Date[]){
  const local = dates.map((date) =>
    date
      .toLocaleDateString("es-MX")
      .split(",")[0]
  );  
  return `${local[0]} - ${local[1]}`;
}

// return date fraction with time reseted to noon so after any time zone -> utc correction the day (year, month) remains same nominal value
export function getDateOnly(dateTime: string |Date, adjust: boolean = false): Date {  
  const date = dateTime instanceof Date ? dateTime : new Date(dateTime);
  const utcDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);  
  if (!adjust) {
    return utcDate;
  }
  const adjustedDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
  return adjustedDate;
}

export function isDateInRange(date: Date, from: string | Date, to: string | Date): boolean {
  const target = getDateOnly(date);
  const start = getDateOnly(new Date(from));
  const end = getDateOnly( new Date(to));
  return target >= start && target <= end;
}


export interface SimpleDate{
  year: number,
  month: number
}
export function isDateBeforeOther(date: SimpleDate, other: SimpleDate): boolean {
  if (date.year == other.year) {
    return date.month <= other.month;
  }
  else
    return date.year < other.year;
}

export function compareSimpleDate(left: SimpleDate, right: SimpleDate) {
  if (left.year !== right.year) return left.year - right.year;
  return left.month - right.month; 
}